export function convertTableSortToOdata(sortBy, sortDesc) {
  // for teamdashboard
  if (sortBy === 'frist') {
    sortBy = 'reiseterminWorkflowFrist/frist';
  }
  return sortBy !== '' ? [sortBy.replaceAll('.', '/') + ' ' + (sortDesc ? 'desc' : 'asc')] : null;
}
